import { ConfirmDialogConfig } from '@agent-ds/shared/components/confirm-dialog/confirm-dialog-config';
import { ConfirmDialogComponent } from '@agent-ds/shared/components/confirm-dialog/confirm-dialog.component';
import { ProgressSearchParams, StudentDetail } from '@agent-ds/shared/interfaces';
import { Tab } from '@agent-ds/shared/models';
import { DialogService, StudentApiService } from '@agent-ds/shared/services';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ag-student-progress-tab',
  templateUrl: './student-progress-tab.component.html',
  styleUrls: ['./student-progress-tab.component.scss'],
  providers: [{ provide: Tab, useExisting: forwardRef(() => StudentProgressTabComponent) }],
})
export class StudentProgressTabComponent extends Tab implements OnChanges {
  @Input() student: StudentDetail;
  requestObject: ProgressSearchParams;

  constructor(private studentApiService: StudentApiService, private readonly dialogService: DialogService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.student != null && changes['student'].currentValue !== changes['student'].previousValue) {
      this.requestObject = {
        studentId: [this.student.id],
      };
    }
  }

  errorGetListCallback(error: HttpErrorResponse) {
    if (!error.status) {
      this.showErrorDialog();
      this.studentApiService.notifyConnectionErrorEvent.emit();
    } else {
      // その他のエラーは共通部分でハンドリングされているのでここではハンドリングしない
    }
  }

  private showErrorDialog() {
    // ダイアログによる通知
    const dialogConfig: ConfirmDialogConfig = ConfirmDialogConfig.createStudentApiErrorDialogConfig([
      '進捗の取得中に通信エラーが発生しました。',
      '画面上部右側の「求職者の全情報を再取得する」ボタンを押して再度取得してください。',
    ]);
    this.dialogService.open(ConfirmDialogComponent, dialogConfig);
  }
}
